import { IComponentOptions } from "angular";
import { ProcessTemplateEditController } from "./controller";
export const vsComponentName = "processEmailTemplateEdit";
export const processTemplateEditComponentOptions: IComponentOptions = {
  controller: ProcessTemplateEditController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    model: "<",
    placeholderOptions: "<",
  },
};
